/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 18:12:53
 * @LastEditTime: 2022-06-02 11:18:40
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import {
  cancel_Submission,
  delete_domain,
  get_domainDetail,
  save_domainDetail,
  verify_domain,
  save_certificate,
} from '@/src/request/salesChannel/setting/domain';
import { NEW } from '@/src/tools/constant';
import { SSLStatusType, EnumStatus } from '@/src/types/common/domain';
import { Form, message } from 'antd';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Warning from '@/src/components/Antd/Modal/WarningModal';
import DNSRecordRecommendation from './DNSRecordRecommendation';
import Domain from './Domain';
import SSLCertificate from './SSLCertificate';
import css from './css.module.less';

const DominEdit = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [formData, setFormData] = useState<any>({});
  const [hasModified, setHasModified] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [btnDisableWhileReq, setBtnDisableWhileReq] = useState(false);
  const params: any = useParams();
  const history: any = useHistory();
  const { uuid: salesChannelUuid, domainUuid } = params;
  const { breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('salesChannelDomainAndStatus.edit.domainandStatusDomain'),
  });
  const currentDomainStatus = get(formData, 'status', '');

  useEffect(() => {
    if (domainUuid !== NEW) {
      requestDomainDetail();
    } else {
      setLoading(false);
    }
  }, []);

  //Get Domain Details
  const requestDomainDetail = () => {
    get_domainDetail(domainUuid).then((data) => {
      const verified =
        get(data, 'certificate.status', '') == SSLStatusType.Verified;

      if (verified && !data.oldCertificate) {
        data.oldCertificate = data.certificate;
        // data.certificate = null;
      }
      setFormData(data);

      setLoading(false);
    });
  };

  const handleRequest = (type, submitFunction) => {
    return new Promise((resolve, reject) => {
      form
        .validateFields(type)
        .then((values) => {
          setBtnDisableWhileReq(true);
          values.salesChannelUuid = salesChannelUuid;
          values.uuid = domainUuid === NEW ? '' : domainUuid;
          values.status = formData.status;
          return submitFunction(values)
            .then((data) => {
              setFormData(data);
              if (domainUuid === NEW && data.uuid) {
                history.replace(
                  `/salesChannel/setting/domain/${salesChannelUuid}/${data.uuid}`,
                );
              }
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            })
            .finally(() => {
              setBtnDisableWhileReq(false);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Submit Domain
  const handleConfirmDomain = (type) => {
    return handleRequest(type, save_domainDetail);
  };

  // Submit SSL
  const handleSubmitCetificate = (type) => {
    return handleRequest(type, save_certificate);
  };

  const handleCancelSubmission = () => {
    cancel_Submission(domainUuid).then((data) => {
      console.log(data);
      message.success(
        getI18n('salesChannelDomainAndStatus.edit.successfullycanceled'),
      );
      setFormData(data);
    });
  };

  const handleDeleteDomain = () => {
    delete_domain(domainUuid)
      .then((data) => {
        message.success(getI18n('general.savesuccess'));
        history.push(`/salesChannel/setting/domain/${salesChannelUuid}`);
      })
      .finally(() => {
        setShowDeleteModal(false);
      });
  };

  const handleVerifyDomain = () => {
    setBtnDisableWhileReq(true);
    verify_domain(domainUuid)
      .then((data) => {
        setFormData(data);
      })
      .finally(() => {
        setBtnDisableWhileReq(false);
      });
  };

  const onGoBackClick = () => {
    history.push(`/salesChannel/setting/domain/${salesChannelUuid}`);
  };
  const commonHeaderProps = {
    breadcrumbData,
    onGoBackClick,
    onSaveDisable: !hasModified,
  };
  return (
    <>
      <Skeleton loading={loading} active>
        {currentDomainStatus === EnumStatus.Deleting ? (
          <CommonHeader {...commonHeaderProps} />
        ) : (
          <CommonHeader
            {...commonHeaderProps}
            onDelete={() => {
              setShowDeleteModal(true);
            }}
          />
        )}
        <Form
          name='domainEdit'
          form={form}
          className={css.formClass}
          initialValues={formData}
          onValuesChange={() => {
            setHasModified(true);
          }}>
          <Domain
            form={form}
            domain={formData.domain}
            status={get(formData, 'certificate.status')}
            confirmDomain={handleConfirmDomain}
          />
          <SSLCertificate
            domain={formData.domain}
            certificate={get(formData, 'certificate', {})}
            domainStatus={get(formData, 'status', {})}
            uploadCertificateStatus={get(
              formData,
              'uploadCertificateStatus',
              '',
            )}
            confirmDomain={handleSubmitCetificate}
            cancelSubmission={handleCancelSubmission}
            errorCode={get(formData, 'errorCode', '')}
            errorMsg={get(formData, 'errorMsg', '')}
            success={get(formData, 'success', '')}
            btnDisableWhileReq={btnDisableWhileReq}
          />
          <DNSRecordRecommendation
            domain={formData.domain}
            domainStatus={get(formData, 'status', '')}
            verifiedDate={get(formData, 'verifiedDate', '')}
            verifyDomain={handleVerifyDomain}
            awsDistributionDomainName={formData.awsDistributionDomainName}
            certificate={get(formData, 'certificate', {})}
            success={get(formData, 'success', '')}
            errorCode={get(formData, 'errorCode', '')}
            errorMsg={get(formData, 'errorMsg', '')}
            distributionStatus={get(formData, 'distributionStatus')}
            btnDisableWhileReq={btnDisableWhileReq}
          />
        </Form>
      </Skeleton>
      {showDeleteModal && (
        <Warning
          visible={showDeleteModal}
          header={getI18n('salesChannelDomainAndStatus.list.deleteDomain')}
          okText={getI18n('general.antd.Modal.ModalFooter.delete')}
          onOk={handleDeleteDomain}
          onCancel={() => setShowDeleteModal(false)}>
          {getI18n('salesChannelDomainAndStatus.list.deleteModalContent')}
        </Warning>
      )}
    </>
  );
};

export default DominEdit;
